import {view} from '@sail/ui';
import {useGroupedMessagesRowV2Gap} from '../../../helpers/useItemsGroupedV2';

type Props = {
  rows: Array<JSX.Element>;
  fillSpace?: boolean;
};

export function GroupedMessagesRowV2({rows, fillSpace}: Props) {
  const gap = useGroupedMessagesRowV2Gap();

  if (rows.length === 0) {
    return null;
  }

  return (
    <view.div
      className={`uh-conversations-grouped-messages v2 ${
        fillSpace ? 'fill-space' : ''
      }`}
      data-testid="grouped-messages-row"
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap,
      }}
    >
      {rows}
    </view.div>
  );
}
